import {
  ITranslationValues,
  KeyPath,
  tr as fpTr,
  fpTranslateEntries,
  fpTranslateEntry,
} from "@backpacker/dico/tr";
import { Locale } from "@linkfluence/models/locale";
import resources from "./resources";

// eslint-disable-next-line @typescript-eslint/ban-types
type Path = KeyPath<typeof resources["en_GB"]> | (string & {});

export const tr = (
  locale: Locale = Locale.English,
  key: Path,
  values: ITranslationValues = {},
  field: string = "count"
) => {
  return fpTr(resources, locale, key, values, field);
};

export const translateEntry = fpTranslateEntry(resources);

export const translateEntries = fpTranslateEntries(resources);
